<div *ngIf="showTooltip" [appCustomerInfoTooltip]="customer?.id" class="customer-render-info"> {{ getCustomerFields() }} </div>
<div *ngIf="!showTooltip" class="customer-render-info"> {{ getCustomerFields() }} </div>
